import moment from 'moment';

const formatDate = (date) => {
    const formattedDate = moment(date).format('MMM-DD, YYYY hh:mm A');   
    return formattedDate; 
}

export default formatDate;